import { searchOverclaimsRHSuggestions } from '@App/api/routes/search'
import { AutoCompleteFetchRequest } from '@App/stores/search/models/select-option-hide'

const getOverclaimAutoCompleteSuggestions = async ({
    property,
    searchTerm,
    rightsholderId,
    signal,
}: AutoCompleteFetchRequest) => {
    if (!rightsholderId) {
        return Promise.resolve([])
    }
    const cleanSearch = encodeURIComponent(searchTerm).toLowerCase()
    const suggestions = await searchOverclaimsRHSuggestions(rightsholderId, property, cleanSearch, signal)
    return suggestions.data || []
}

export default getOverclaimAutoCompleteSuggestions
